import catalog from './insightsArticles.json';

const ARTICLES = Array.isArray(catalog?.articles) ? catalog.articles : [];

export function listInsightsArticles() {
  return ARTICLES.slice().sort((a, b) =>
    String(b.published_at || '').localeCompare(String(a.published_at || ''))
  );
}

export function getInsightsArticle(slug) {
  if (!slug) return null;
  return ARTICLES.find((a) => a.slug === slug) || null;
}

export function insightsArticlePath(slug) {
  return `/insights/${encodeURIComponent(slug)}`;
}

export function formatInsightsDate(iso) {
  if (!iso) return '';
  const [y, m, d] = String(iso).split('-');
  if (!y || !m || !d) return iso;
  return `${y}年${Number(m)}月${Number(d)}日`;
}
